import NiceModal, { useModal } from '@ebay/nice-modal-react'
import type { ReactNode } from 'react'

import closeModal from '../../utils/closeModal'
import Modal from './modal'

type MessageModalType = {
  message?: ReactNode | string
  title?: string
  onClick?: (() => void) | null
}

const MessageModal = ({ title, message, onClick }: MessageModalType) => {
  const modal = useModal()

  return (
    <Modal id="message-modal" zIndex={335}>
      {title && (
        <p className="text-txt text-2xl font-black text-center mb-5 xl:text-3xl">
          {title}
        </p>
      )}
      {message &&
        (typeof message === 'string' ? (
          <p className="text-[15px] text-txt text-center font-normal xl:text-xl [&>span]:font-bold">
            {message}
          </p>
        ) : (
          message
        ))}
      <div className="flx-ctr mt-[25px]">
        <button
          className="w-[120px] text-center text-lg bg-primary-btn-bg border-primary-btn-bg text-primary-btn-txt transition-all duration-[0.2s] ease-[ease-in-out] cursor-pointer font-normal px-0 py-[7px] rounded-[22px] border-[1.5px] border-solid xl:text-xl xl:w-[170px] xl:px-0 xl:py-2.5 xl:rounded-[26px]"
          onClick={() => {
            onClick?.()
            closeModal(modal)
          }}>
          Ok
        </button>
      </div>
    </Modal>
  )
}

export default NiceModal.create(MessageModal)
